import { Config } from "../../../configurations/config"
export const Designation_API = {
    //------------------------ View Employee APIS -----------------------//

    GetDesignationList: `${Config.server_url}${Config.api_prefix}/Designation`,
    GetDepartment: `${Config.server_url}${Config.api_prefix}/Department/GetAllDepartments`,
    CreateDesignation: `${Config.server_url}${Config.api_prefix}/Designation`

}
